"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M2 1h1v4H2V1zm4 1h16v2H6V2zm4 18h12v2H10v-2zm12-9H8v2h14v-2zM3 10H2v4h1v-4zm1 0h1v4H4v-4zm-1 9H2v4h1v-4zm1 0h1v4H4v-4zm3 0H6v4h1v-4z" }), "OrderedList");
//# sourceMappingURL=OrderedList.js.map